// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__DOves","toggleWrap":"styles_toggleWrap__3Oa_U","content":"styles_content__2AqUn","selectAreaCode":"styles_selectAreaCode__3NSDF"};